<script>
import { Cell } from 'vant'
import PickerSelector from '@/components/org/PickerSelector'
import ObjectFunc from '@/tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'group-picker',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'picker-selector': PickerSelector,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        /**
         * The roles contains the role label and its value. 
         * role item: {label, value}
         */
        roles: Array,
        /**
         * The options contains the picker options. 
         * picker option: {label, value}
         */
        options: Array,
        /**
         * The items contains the role values. 
         * item: {roleValue, optionValue, optionLabel}
         */
        items: Array,
        disabled: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            /**
             * The items contains the role values. 
             * item: {roleValue, optionValue, optionLabel}
             */
            roleItems: []
        }
    },

    watch: {
        items(value) {
             console.log('watch items', value)
            this.roleItems = ObjectFunc.cloneObject(value)
        }
    },
    
    mounted() {
         console.log('mounted', this.items)
        this.roleItems = ObjectFunc.cloneObject(this.items)
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        roleOptions(index) {
            const optionList = []
            const role = this.roles[index]
            for (let i = 0; i < this.options.length; i++) {
                let option = this.options[i]
                let existed = false
                for (let j = 0; j < this.roleItems.length; j++) {
                    let item = this.roleItems[j]
                    if (role.value != item.roleValue && option.value == item.optionValue) {
                        existed = true
                        break
                    }
                }
                if (!existed) {
                    optionList.push(option)
                }
            }
            return optionList
        },
        roleOptionValue(index) {
            // console.log('roleOptionValue', index, JSON.stringify(this.roleItems))
            const role = this.roles[index]
            for (let j = 0; j < this.roleItems.length; j++) {
                let item = this.roleItems[j]
                if (item.roleValue == role.value) {
                    for (let k = 0; k < this.options.length; k++) {
                        let option = this.options[k]
                        if (item.optionValue == option.value) {
                            return option.value
                        }
                    }
                }
            }
            return
        },
        roleOptionIndex(index) {
            const role = this.roles[index]
            for (let j = 0; j < this.roleItems.length; j++) {
                let item = this.roleItems[j]
                if (item.roleValue == role.value) {
                    for (let k = 0; k < this.options.length; k++) {
                        let option = this.options[k]
                        if (item.optionValue == option.value) {
                            return k
                        }
                    }
                }
            }
            return
        },
        roleValue(index) {
            // console.log('roleValue', index, JSON.stringify(this.roleItems))
            const role = this.roles[index]
            for (let j = 0; j < this.roleItems.length; j++) {
                let item = this.roleItems[j]
                if (item.roleValue == role.value) {
                    return item.optionLabel
                }
            }
            return
        },
        onRoleOptionDataChange(data) {
             console.log('onRoleOptionDataChange', data, data.value)
            const role = this.roles[Number(data.id)]
            for (let i = 0; i < this.roleItems.length; i++) {
                let item = this.roleItems[i]
                if (item.roleValue == role.value) {
                    if (data.value) {
                        item.optionValue = data.value
                        item.optionLabel = data.label
                    }
                    else {
                        this.roleItems.splice(i, 1)
                    }
                    this.$emit('change-data', ObjectFunc.cloneObject(this.roleItems))
                    return
                }
            }
            this.roleItems.push({roleValue: role.value, optionValue: data.value, optionLabel: data.label})
            this.$emit('change-data', ObjectFunc.cloneObject(this.roleItems))
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="group-picker">
        <div class="picker-container">
            <div v-for="(role, index) in roles" :key="index" class="relative">
                <div v-if="!disabled">
                    <picker-selector
                        :id="index.toString()"
                        :label="role.label"
                        :options="roleOptions(index)"
                        :value="roleOptionValue(index)"
                        :index="roleOptionIndex(index)"
                        :clearable="true"
                        @change-data="onRoleOptionDataChange"
                    />
                    <div class="separator-line-bottom"/>
                </div>
                <div v-else>
                    <van-cell
                        :class="{ disabled: disabled }"
                        :title="role.label"
                        :value="roleValue(index)"
                        center
                    />
                </div>
            </div>
        </div>
    </div>
</template>